import { Injectable } from '@angular/core';
import { Subject } from '../../../../node_modules/rxjs/Subject';
import { Cliente } from '../../core/modelos/cliente';
import { Observable } from '../../../../node_modules/rxjs/Observable';

@Injectable()
export class ToolbarService {

    public clienteAdmin: Subject<Cliente>;

    constructor() {
        this.clienteAdmin = new Subject<Cliente>();
     }

    setClienteAdmin(cliente: Cliente) {
        this.clienteAdmin.next(cliente);
    }

    getClienteAdmin(): Observable<any> {
        return this.clienteAdmin.asObservable();
    }

}



// WEBPACK FOOTER //
// ./src/app/main/toolbar/toolbar.service.ts